import { FunctionComponent } from "react";
import { Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ManagementCompareSelects,
  type ManagementCompareSelectsProps
} from "./ManagementCompareSelects";
import { ManagementToolbarField } from "./ManagementToolbarField";

type ManagementCompareToolbarFieldsProps = ManagementCompareSelectsProps;

/**
 * Toolbar row shown after a compare floor is selected — edit location/floor.
 */
export const ManagementCompareToolbarFields: FunctionComponent<
  ManagementCompareToolbarFieldsProps
> = props => {
  const { t } = useTranslation();

  return (
    <Grid2
      container
      spacing={2}
      alignItems="flex-end"
      data-testid="management-compare-toolbar"
      sx={{ mt: 2 }}
    >
      <Grid2 size={{ xs: 12, md: 4 }}>
        <ManagementToolbarField label={t("Compare")} labelId="management-compare-select-label">
          <ManagementCompareSelects {...props} locationLabelId="management-compare-select-label" />
        </ManagementToolbarField>
      </Grid2>
    </Grid2>
  );
};
